module.exports = __webpack_public_path__ + "static/media/ng.ccd73943.svg";